<template>
    <div class="board-withdrawn">
        <!-- 查询段（独立白底卡·结构对齐 boardSchedule） -->
        <div class="query-box mb10" v-loading="filterLoading">
            <el-form inline :model="formData" size="mini" class="filter-bar">
                <!-- 工单 -->
                <el-form-item prop="work_order" v-if="getCustomFilterShow('work_order')">
                    <OrderProjectFilter mode="work_order" label="工单" search-api="schedule_manage" v-model="woFilter" @del="handleDelFilter('work_order')"/>
                </el-form-item>
                <!-- 项目 -->
                <el-form-item prop="project_id" v-if="getCustomFilterShow('project_id')">
                    <OrderProjectFilter mode="project_id" label="项目" search-api="schedule_manage" v-model="projFilter" @del="handleDelFilter('project_id')"/>
                </el-form-item>
                <!-- 客户名称（远程多选 + 批量粘贴） -->
                <el-form-item prop="company_name" v-if="getCustomFilterShow('company_name')">
                    <CustomInput label="客户名称" @append-click="handleGenAppendClick('company_name', '输入或粘贴客户名称，每行一个')">
                        <ESelect v-model="formData.company_name" filterable clearable placeholder="请输入客户名称搜索选择"
                                 multiple collapse-tags remote reserve-keyword :loading="searchLoading" ref="company_name"
                                 @visible-change="(val) => handleVisibleChange(val, 'company_name')"
                                 :remote-method="(search) => appEntrySearchList(search, 'company_name')">
                            <p class="option-select">
                                <el-button type="text" @click="() => handleSelectAll(company_name_DataList, 'company_name', 'all')">全选</el-button>
                                <el-button type="text" @click="() => handleSelectAll(company_name_DataList, 'company_name', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option v-for="item in company_name_DataList" :key="item.value" :label="item.label" :value="item.value"/>
                        </ESelect>
                        <template #append><i class="el-icon-document-copy"/></template>
                        <template #appendOrther>
                            <div :style="{ color: 'red', display: 'inline-block' }">
                                <i class="el-icon-close" @click="handleDelFilter('company_name')"/>
                            </div>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 集团名称（远程多选 + 批量粘贴） -->
                <el-form-item prop="bloc_name" v-if="getCustomFilterShow('bloc_name')">
                    <CustomInput label="集团名称" @append-click="handleGenAppendClick('bloc_name', '输入或粘贴集团名称，每行一个')">
                        <ESelect v-model="formData.bloc_name" filterable clearable placeholder="请输入集团名称搜索选择"
                                 multiple collapse-tags remote reserve-keyword :loading="searchLoading" ref="bloc_name"
                                 @visible-change="(val) => handleVisibleChange(val, 'bloc_name')"
                                 :remote-method="(search) => appEntrySearchList(search, 'bloc_name')">
                            <p class="option-select">
                                <el-button type="text" @click="() => handleSelectAll(bloc_name_DataList, 'bloc_name', 'all')">全选</el-button>
                                <el-button type="text" @click="() => handleSelectAll(bloc_name_DataList, 'bloc_name', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option v-for="item in bloc_name_DataList" :key="item.value" :label="item.label" :value="item.value"/>
                        </ESelect>
                        <template #append><i class="el-icon-document-copy"/></template>
                        <template #appendOrther>
                            <div :style="{ color: 'red', display: 'inline-block' }">
                                <i class="el-icon-close" @click="handleDelFilter('bloc_name')"/>
                            </div>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 产品类型 -->
                <el-form-item prop="app_type" v-if="getCustomFilterShow('app_type')">
                    <CustomInput label="产品类型">
                        <SelectAll :options="opt.app_type" v-model="formData.app_type" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('app_type')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 包体类型 -->
                <el-form-item prop="package_type" v-if="getCustomFilterShow('package_type')">
                    <CustomInput label="包体类型">
                        <SelectAll :options="opt.package_type" v-model="formData.package_type" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('package_type')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 游戏分类 -->
                <el-form-item prop="game_classify" v-if="getCustomFilterShow('game_classify')">
                    <CustomInput label="游戏分类">
                        <SelectAll :options="opt.game_classify" v-model="formData.game_classify" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('game_classify')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 媒体 -->
                <el-form-item prop="plat_id" v-if="getCustomFilterShow('plat_id')">
                    <CustomInput label="媒体">
                        <SelectAll :options="opt.plat" v-model="formData.plat_id" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('plat_id')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 素材类型 -->
                <el-form-item prop="material_type" v-if="getCustomFilterShow('material_type')">
                    <CustomInput label="素材类型">
                        <SelectAll :options="opt.material_type" v-model="formData.material_type" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('material_type')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 投放场景 -->
                <el-form-item prop="delivery_scene" v-if="getCustomFilterShow('delivery_scene')">
                    <CustomInput label="投放场景">
                        <SelectAll :options="opt.delivery_scene" v-model="formData.delivery_scene" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('delivery_scene')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 投放版位 -->
                <el-form-item prop="delivery_type" v-if="getCustomFilterShow('delivery_type')">
                    <CustomInput label="投放版位">
                        <SelectAll :options="opt.delivery_type" v-model="formData.delivery_type" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('delivery_type')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 紧急度 -->
                <el-form-item prop="urgent_level" v-if="getCustomFilterShow('urgent_level')">
                    <CustomInput label="紧急度">
                        <SelectAll :options="opt.urgent_level" v-model="formData.urgent_level" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('urgent_level')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 制作部门 = 排单**落点组**（改落点后的当前承接组·没排过回退下单组）。
                     与下方「下单制作部门」是两个东西，别合并。后端 appendGroupFilters 走 effectiveGroupInSql。 -->
                <el-form-item prop="material_group" v-if="getCustomFilterShow('material_group')">
                    <CustomInput label="制作部门">
                        <SelectAll :options="opt.order_group" v-model="formData.material_group" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('material_group')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 下单制作部门 = 下单时指定的组 o.group_id，**不随改落点变**（2026-07-22） -->
                <el-form-item prop="order_group" v-if="getCustomFilterShow('order_group')">
                    <CustomInput label="下单制作部门">
                        <SelectAll :options="opt.order_group" v-model="formData.order_group" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('order_group')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 是否新品 -->
                <el-form-item prop="is_new" v-if="getCustomFilterShow('is_new')">
                    <CustomInput label="是否新品">
                        <SelectAll :options="opt.is_new" v-model="formData.is_new" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('is_new')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 游戏类型 -->
                <el-form-item prop="project_tag11" v-if="getCustomFilterShow('project_tag11')">
                    <CustomInput label="游戏类型">
                        <SelectAll :options="opt.project_tag11" v-model="formData.project_tag11" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('project_tag11')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 游戏题材 -->
                <el-form-item prop="project_tag12" v-if="getCustomFilterShow('project_tag12')">
                    <CustomInput label="游戏题材">
                        <SelectAll :options="opt.project_tag12" v-model="formData.project_tag12" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('project_tag12')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 创建人（远程） -->
                <el-form-item prop="create_uid" v-if="getCustomFilterShow('create_uid')">
                    <CustomInput label="创建人">
                        <SelectAll :options="create_user_DataList" v-model="formData.create_uid" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('create_uid')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 创建人部门（远程） -->
                <el-form-item prop="user_group" v-if="getCustomFilterShow('user_group')">
                    <CustomInput label="创建人部门">
                        <SelectAll :options="user_group_DataList" v-model="formData.user_group" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('user_group')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 工单标签（远程） -->
                <el-form-item prop="work_order_label" v-if="getCustomFilterShow('work_order_label')">
                    <CustomInput label="工单标签">
                        <SelectAll :options="work_order_label_DataList" v-model="formData.work_order_label" placeholder="全部"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('work_order_label')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 期望完成时间 -->
                <el-form-item prop="expected_end_time" v-if="getCustomFilterShow('expected_end_time')">
                    <CustomInput label="期望完成时间">
                        <el-date-picker v-model="formData.expected_end_time_range" type="daterange" value-format="yyyy-MM-dd"
                                        size="mini" range-separator="至" start-placeholder="起" end-placeholder="止" style="width:230px"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('expected_end_time')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 创建时间 -->
                <el-form-item prop="range_time" v-if="getCustomFilterShow('range_time')">
                    <CustomInput label="创建时间">
                        <el-date-picker v-model="formData.range_time_range" type="daterange" value-format="yyyy-MM-dd"
                                        size="mini" range-separator="至" start-placeholder="起" end-placeholder="止" style="width:230px"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('range_time')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 撤回时间（2026-07-31）：o.delete_time。本 tab 的核心时间维度，控件模式照搬期望完成时间 -->
                <el-form-item prop="delete_time" v-if="getCustomFilterShow('delete_time')">
                    <CustomInput label="撤回时间">
                        <el-date-picker v-model="formData.delete_time_range" type="daterange" value-format="yyyy-MM-dd"
                                        size="mini" range-separator="至" start-placeholder="起" end-placeholder="止" style="width:230px"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('delete_time')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- 驳回时间（2026-07-31）：o.rejected_time。撤回单里「先被驳回后又被撤」的那批靠它定位 -->
                <el-form-item prop="rejected_time" v-if="getCustomFilterShow('rejected_time')">
                    <CustomInput label="驳回时间">
                        <el-date-picker v-model="formData.rejected_time_range" type="daterange" value-format="yyyy-MM-dd"
                                        size="mini" range-separator="至" start-placeholder="起" end-placeholder="止" style="width:230px"/>
                        <template #append><i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('rejected_time')"/></template>
                    </CustomInput>
                </el-form-item>
                <!-- +添加筛选 -->
                <el-form-item>
                    <FilterPopSelect :list="listMap" :value="customFilter" @change="onFilterChange"/>
                </el-form-item>
            </el-form>
            <div class="opts">
                <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
                <el-button size="mini" @click="handleReset">重置</el-button>
            </div>
        </div>

        <!-- 子tab栏（查询卡下方、表格上方，由容器传入） -->
        <ObliqueTags v-if="tabTags.length" :tags="tabTags" :value="activeTab" @tab-click="v=>$emit('tab-switch', v)"/>

        <!-- 表格段 -->
        <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5">
            <div class="operation-box mb10">
                <div class="operation-left">
                    <el-button size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
                    <span class="op-tip">已撤回工单：工单被撤回作废后归档于此，仅查看不可操作。按制作部门可见（排单落点优先，未排单的按下单部门）。</span>
                </div>
                <div class="operation-right">
                    <el-button icon="el-icon-s-operation" size="mini" @click="handleFieldTable">自定义列</el-button>
                    <el-button icon="el-icon-download" size="mini" :loading="exportLoading" @click="exportData">导出</el-button>
                </div>
            </div>

            <!-- 动态列表格（结构对齐 boardSchedule：序号列 + min-width + align=left + 双击复制）。
                 ⚠️ 需求方明确：工单管理已撤回列表里的操作不要 → 无操作列、无多选列。
                 列池里的 controls(操作列)已在 fetchGetCustomField 里过滤掉，不会渲染成空列。 -->
            <jt-table v-loading="loading" :data="list" border stripe style="width:100%"
                      header-cell-class-name="header-cell" @sort-change="handleSortChange"
                      @header-dragend="handleDragEnd">
                <!-- 序号列（固定左侧·同 boardSchedule） -->
                <el-table-column label="序号" align="center" width="56" fixed="left">
                    <template slot-scope="{$index}">{{ (page - 1) * pageSize + $index + 1 }}</template>
                </el-table-column>

                <el-table-column v-for="(col, idx) in columns" :key="col.id + '_' + idx"
                                 :prop="col.id" :label="col.display_name"
                                 :width="colWidthMap[col.id] || col.width || ''" :min-width="col.width ? '' : 90"
                                 :fixed="col.fixed ? col.fixed : false" :sortable="sortableOf(col.id)" align="left">
                    <template slot-scope="{row}">
                        <div @dblclick="copyText(cellCopyText(col.id, row))">
                            <!-- 工单标签：[{id,name}] 对象数组 → tag。直接 join 会出 [object Object] -->
                            <div v-if="col.id === 'work_order_label'">
                                <template v-for="lb in (row.work_order_label || [])">
                                    <el-tag type="warning" :key="lb.id" size="mini" style="margin-right:4px">{{ lb.name }}</el-tag>
                                </template>
                                <span v-if="!(row.work_order_label || []).length">-</span>
                            </div>
                            <!-- 需求信息：[{info}] 对象数组 → 逐行 -->
                            <div v-else-if="col.id === 'detail_info'">
                                <div v-for="(d, i) in (row.detail_info || [])" :key="i" class="cell-line">{{ d.info || d }}</div>
                                <span v-if="!(row.detail_info || []).length">-</span>
                            </div>
                            <!-- 集团/客户名称：可能是数组 -->
                            <div v-else-if="col.id === 'bloc_name' || col.id === 'company_name'">
                                <span v-if="Array.isArray(row[col.id])">{{ (row[col.id] || []).join('；') || '-' }}</span>
                                <span v-else>{{ row[col.id] || '-' }}</span>
                            </div>
                            <!-- 紧急度：紧急标红（同工单管理 urgent_level==2） -->
                            <div v-else-if="col.id === 'urgent_level_text'">
                                <span :style="{ color: row.urgent_level == 2 ? '#ff0000' : '' }">{{ row[col.id] || '-' }}</span>
                            </div>
                            <!-- 撤回原因/内容要求等长文本：允许换行 -->
                            <div v-else-if="col.id === 'delete_reason' || col.id === 'special_content' || col.id === 'content'"
                                 class="cell-wrap">{{ row[col.id] || '-' }}</div>
                            <!-- 其余：标量兜底（数组也按字符串数组处理） -->
                            <span v-else>{{ cellText(row, col.id) }}</span>
                        </div>
                    </template>
                </el-table-column>
            </jt-table>

            <!-- 分页：page-sizes / layout 对齐工单管理已撤回(含 jumper)，默认 30 条 -->
            <div class="tar mt10">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
                               :current-page="page" :page-size="pageSize" :page-sizes="[30,50,100]"
                               @current-change="onPageChange" @size-change="onSizeChange"/>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * 排单管理「已撤回工单」tab（2026-07-22）
     *
     * 口径（后端 TdWorkOrderScheduleManageService::getWithdrawnList）：
     *   · o.order_status = 5，含**从没进过排单池**的单
     *   · 可见性走**指派那套**（角色数据范围 + 组下钻），归属组 = 排单落点优先·没排过回退下单组
     *   · order_status 由服务端强制，前端传什么都没用
     *
     * ⚠️ 三件必须与 boardSchedule 保持一致、不要「就近」改成工单管理那套的东西：
     *   ① 搜索下拉走 materialAPI.postScheduleManageSearchList（排单管理独立接口·挂 7543）。
     *      改回工单管理的 postSearchWorkOrderMethodOptions → 有排单权无工单权的用户 403（BUG-002-AY 原型）。
     *   ② 动态筛选配置 field_type = scheduling_withdrawn_filter（本 tab 独占，不与三 tab 共享）。
     *   ③ 自定义列 field_type = scheduling_withdrawn（**不带 sub_type**，后端 subDenyFields 按该键取）。
     */
    import API from '@/api/workOrder/scheduleManage.js';
    import schedulingAPI from '@/api/workOrder/scheduling.js';
    import materialAPI from '@/api/workOrder/material.js';
    import SelectAll from '@/components/SelectAll';
    import CustomInput from '@/components/CustomInput';
    import FilterPopSelect from '@/views/workOrder/components/filterPopSelect.vue';
    import ObliqueTags from '@/views/workOrder/components/obliqueTags.vue';
    import OrderProjectFilter from '@/views/workOrder/components/orderProjectFilter.vue';
    import { fieldTableModal } from '@/views/workOrder/modal';
    import { batchSelectModal } from '@/components/modal';
    import copyTextMixin from '@/mixins/copyText';
    import { setStorage, getStorage } from '@/utils/index.js';

    /**
     * 从 board（待排单/已排单/已定版 三 tab 共享查询）带过来的筛选键（2026-07-31）。
     *
     * 🔴 行为要求：与三 tab 互切**完全一致**——切过来后筛选生效、**控件里看得见**、能改能清。
     *    所以这些键是直接写进本页 `formData`（见 applySharedFilters），不是只补在出参上。
     *
     * 入选标准只有一条：**两边同名 且 同义**（后端 formatConditionsByParams 与 buildWhere 对该键的
     * 解释一致）。刻意排除的三类：
     *   ① board 特有的排单键：scheduling_status / group_id / delivery* / expect_finish_date* /
     *      bloc_star / overdue / priority / category_group_id / cross_cat / bloc_id / search
     *      —— 本 tab 的后端路径（getWorkOrderList）压根不认，或按另一套语义解释；
     *   ② 分页与排序：page / page_size / order_fields / order —— 各自维护（方案「非本期」已定）；
     *   ③ 同义但不同名的：board 的 ctime_start/ctime_end ↔ 本组件 range_time（格式也不同）、
     *      board 的 group_id（制作部门=纯落点组）↔ 本组件 material_group（落点优先·回退下单组）。
     *      做键名翻译等于新开一条要长期对齐的口径，两边任一侧改格式就会悄悄漂掉，得不偿失。
     */
    const SHARED_INHERIT_KEYS = [
        'bloc_name', 'company_name', 'app_type', 'game_classify', 'plat_id', 'package_type', 'material_type',
        'delivery_scene', 'delivery_type', 'urgent_level', 'order_group',
        'create_uid', 'user_group', 'work_order_label', 'is_new', 'project_tag11', 'project_tag12',
    ];

    /**
     * 两边**同名但类型不同**的键：board 侧是单选标量（`''`），本页是多选数组（`[]`）。
     * 写进本页 formData 前必须包成数组，否则 SelectAll 多选控件拿到字符串会渲染错乱。
     * 其余 15 个共享键两边都是数组，直接浅拷贝即可。
     */
    const SCALAR_ON_BOARD_KEYS = ['order_group', 'is_new'];

    export default {
        name: 'BoardWithdrawn',
        mixins: [copyTextMixin],
        components: { SelectAll, CustomInput, FilterPopSelect, ObliqueTags, OrderProjectFilter },
        props: {
            tabTags: { type: Array, default: () => [] },
            activeTab: { type: String, default: '' },
            // board 三 tab 共享查询的**表单快照** { formData, woFilter, projFilter }
            // （由 index.vue 在切到本 tab 那一刻拍下）。
            // 本组件是 v-if 挂载/销毁，故只在挂载时读一次（见 applySharedFilters），不做 watch：
            // 本 tab 在前台时 board 已 v-show 隐藏、用户改不了它，快照与实时等价。
            sharedParams: { type: Object, default: () => ({}) },
        },
        data() {
            return {
                // 列宽本地记忆（2026-08-31）：与指派/任务/工单管理同款，key 各页独立。
                // 拖动表头 → handleDragEnd 写 localStorage；渲染时 :width 优先取这里的值。
                colWidthMap: getStorage('localStorage', 'scheduleWithdrawnTableWidthMap') || {},
                loading: false,
                filterLoading: false,
                exportLoading: false,
                searchLoading: false,
                list: [],
                total: 0,
                page: 1,
                pageSize: 30,
                columns: [],
                modalList: [],
                selectList: [],
                customFilter: [],
                // 「+添加筛选」可选项。
                // ⚠️ 字段名必须是 `label` 不是 `display_name` —— FilterPopSelect 渲染的是 {{item.label}}，
                //    写错了浮层里 checkbox 一片空白（2026-07-22 实测踩过）。
                // ⚠️ `name` 必须与后端 scheduling_withdrawn_filter 白名单逐字对应，否则勾了存不上
                //    （后端 array_intersect 会把它滤掉）。
                listMap: [
                    { name: 'work_order', label: '工单名称' },
                    { name: 'project_id', label: '项目名称' },
                    { name: 'company_name', label: '客户名称' },
                    { name: 'bloc_name', label: '集团名称' },
                    { name: 'app_type', label: '产品类型' },
                    { name: 'package_type', label: '包体类型' },
                    { name: 'game_classify', label: '游戏分类' },
                    { name: 'plat_id', label: '媒体' },
                    { name: 'material_type', label: '素材类型' },
                    { name: 'delivery_scene', label: '投放场景' },
                    { name: 'delivery_type', label: '投放版位' },
                    { name: 'urgent_level', label: '任务紧急程度' },
                    { name: 'material_group', label: '制作部门' },
                    { name: 'order_group', label: '下单制作部门' },
                    { name: 'create_uid', label: '创建人' },
                    { name: 'user_group', label: '创建人部门' },
                    { name: 'work_order_label', label: '工单标签' },
                    { name: 'is_new', label: '是否新品' },
                    { name: 'project_tag11', label: '游戏类型' },
                    { name: 'project_tag12', label: '游戏题材' },
                    { name: 'expected_end_time', label: '期望完成日期' },
                    { name: 'range_time', label: '创建日期' },
                    // 2026-07-31 新增。name 必须与后端 scheduling_withdrawn_filter 白名单
                    // (CustomFieldController::filter) 逐字一致，否则勾了会被 array_intersect 滤掉存不上。
                    { name: 'delete_time', label: '撤回时间' },
                    { name: 'rejected_time', label: '驳回时间' },
                ],
                opt: {
                    app_type: [], game_classify: [], plat: [], package_type: [], material_type: [],
                    order_group: [], delivery_scene: [], delivery_type: [], urgent_level: [], is_new: [],
                    project_tag11: [], project_tag12: [],
                },
                create_user_DataList: [],
                user_group_DataList: [],
                work_order_label_DataList: [],
                company_name_DataList: [],
                bloc_name_DataList: [],
                woFilter: { type: '1', ids: [], search: '' },
                projFilter: { type: '1', ids: [], search: '' },
                // 可排序列。口径抄工单管理 material/index.vue 的 sortList + 它对 tagsActive=5(已撤回)
                // 额外放开的 rejected_time。后端走 order_fields + order 两个参数。
                sortableFields: ['order_id', 'material_num', 'expected_end_time', 'ctime', 'delete_time', 'rejected_time'],
                orderFields: '',
                orderType: '',
                formData: this.defaultForm(),
            };
        },
        mounted() {
            this.loadOptions();
            // 继承在 fetchGetFilter 的 finally 里做 —— 必须等 customFilter 落定之后，见 applySharedFilters
            this.fetchGetFilter();
        },
        methods: {
            defaultForm() {
                return {
                    company_name: [], bloc_name: [], app_type: [], package_type: [], game_classify: [],
                    plat_id: [], material_type: [], delivery_scene: [], delivery_type: [], urgent_level: [],
                    material_group: [], order_group: [], create_uid: [], user_group: [], work_order_label: [],
                    is_new: [], project_tag11: [], project_tag12: [],
                    expected_end_time_range: [], range_time_range: [],
                    // 撤回/驳回时间（2026-07-31）：前端存 [起, 止] 数组，buildQueryParams 里拼成 "起/止" 单串
                    delete_time_range: [], rejected_time_range: [],
                };
            },
            // ——— 动态筛选 ———
            getCustomFilterShow(name) { return this.customFilter.includes(name); },
            async fetchGetFilter() {
                this.filterLoading = true;
                try {
                    const { data } = await schedulingAPI.getSchedulingFilter({ field_type: 'scheduling_withdrawn_filter' });
                    const defaults = ['work_order', 'project_id', 'app_type', 'game_classify', 'plat_id', 'material_type'];
                    this.customFilter = (data && data.length > 0) ? data : defaults;
                } catch (e) {
                    this.customFilter = ['work_order', 'project_id', 'material_type'];
                } finally {
                    this.filterLoading = false;
                    // 🔴 时序：必须在 customFilter 落定之后、首次 getList 之前。
                    //    继承来的键要同时进 customFilter，否则控件被 getCustomFilterShow 挡住不渲染，
                    //    又变回「筛选生效但看不见」。
                    this.applySharedFilters();
                    this.fetchGetCustomField();
                }
            },
            async saveFilter(filters) {
                try {
                    const filterItems = this.listMap.filter(item => filters.includes(item.name));
                    await schedulingAPI.editSchedulingFilter({ field_type: 'scheduling_withdrawn_filter', filters: filterItems });
                } catch (e) { /* ignore */ }
            },
            onFilterChange(values) {
                this.customFilter = values;
                // 取消勾选的字段清值，否则「看不见但仍在生效」的隐藏筛选会让用户查不到东西却找不到原因
                this.listMap.forEach(({ name }) => {
                    if (values.includes(name)) return;
                    if (name === 'work_order') { this.woFilter = { type: '1', ids: [], search: '' }; return; }
                    if (name === 'project_id') { this.projFilter = { type: '1', ids: [], search: '' }; return; }
                    if (name === 'expected_end_time') { this.formData.expected_end_time_range = []; return; }
                    if (name === 'range_time') { this.formData.range_time_range = []; return; }
                    if (name === 'delete_time') { this.formData.delete_time_range = []; return; }
                    if (name === 'rejected_time') { this.formData.rejected_time_range = []; return; }
                    if (name in this.formData) {
                        this.formData[name] = Array.isArray(this.formData[name]) ? [] : '';
                    }
                });
                this.saveFilter(values);
            },
            handleDelFilter(name) {
                const idx = this.customFilter.indexOf(name);
                if (idx > -1) {
                    const next = [...this.customFilter];
                    next.splice(idx, 1);
                    this.onFilterChange(next);
                }
            },
            // ——— 选项 ———
            async loadOptions() {
                try {
                    const { data } = await API.getOptions({});
                    this.opt.order_group = data.order_group || [];
                    this.opt.plat = data.plat || [];
                    this.opt.package_type = data.package_type || [];
                    this.opt.material_type = data.material_type || [];
                    this.opt.delivery_scene = data.delivery_scene || [];
                    this.opt.delivery_type = data.delivery_type || [];
                    this.opt.urgent_level = data.urgent_level || [];
                    this.opt.is_new = data.is_new || [];
                    this.opt.project_tag11 = data.project_tag11 || [];
                    this.opt.project_tag12 = data.project_tag12 || [];
                    // 产品类型/游戏类型：getOptions 已返（v4 BUG-002-BT）·别再跨页调集团星级 get_search_options(不勾该节点即 403)
                    this.opt.app_type = data.app_type || [];
                    this.opt.game_classify = data.game_classify || [];
                } catch (e) { /* ignore */ }
                // 三项远程搜索控件的初始候选（走排单管理独立搜索接口）
                ['create_user', 'user_group', 'work_order_label'].forEach(async (type) => {
                    try {
                        const { data } = await materialAPI.postScheduleManageSearchList({ search_type: type, search: '', batch_search: '' });
                        const mapped = (data.list || []).map(v => ({ ...v, value: v.id, label: v.name }));
                        if (type === 'create_user') this.create_user_DataList = mapped;
                        else this[`${type}_DataList`] = mapped;
                    } catch (e) { /* ignore */ }
                });
            },
            // ——— 远程搜索 / 批量粘贴（走排单管理独立接口·勿改回工单管理那个） ———
            async appEntrySearchList(search, type, p = {}, cb) {
                try {
                    const params = { search_type: type, search, ...p };
                    this.searchLoading = true;
                    const { data } = await materialAPI.postScheduleManageSearchList(params);
                    const list = data.list || [];
                    const errList = data.err_list || [];
                    if (params.batch_search) {
                        // 第三参 err_groups：后端把「未找到」的单按当前状态归类（仅 search_type=work_order 非空）。
                        // 纯增参数，err_list 与剔除语义一字未动。
                        cb(errList, () => {
                            const ids = list.map(v => v.id);
                            this[`${type}_DataList`] = [
                                ...this[`${type}_DataList`].filter(v => this.formData[type].includes(v.value) && !ids.includes(v.value)),
                                ...list.map(v => ({ ...v, value: v.id, label: v.name })),
                            ];
                            this.formData[type] = [...new Set([...this.formData[type], ...ids])];
                        }, data.err_groups || []);
                    } else {
                        this[`${type}_DataList`] = list.map(v => ({ ...v, value: v.id, label: v.name }));
                    }
                } catch (error) {
                    this.$message.warning((error && error.info) || '搜索失败');
                } finally {
                    this.searchLoading = false;
                }
            },
            handleGenAppendClick(type, placeholder) {
                const onSubmit = (data, callback) => {
                    this.appEntrySearchList('', type, { batch_search: data }, (errs, cb, errGroups) => {
                        callback();
                        if (errs.length) {
                            const onOk = () => { cb(); vm.close(); };
                            // 后端给了归类（仅工单类型）→ 分组弹框；否则退回原弹框，行为与改动前完全一致。
                            // ⚠️ 两条分支的「剔除」动作是同一个 onOk —— 归类只改展示，不改剔除语义。
                            if (errGroups && errGroups.length) {
                                delErrGroupList({
                                    tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?（已按工单当前状态归类，可分组复制）',
                                    groups: errGroups,
                                    onOk,
                                });
                            } else {
                                delErrList({
                                    tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?',
                                    list: errs,
                                    onOk,
                                });
                            }
                        } else {
                            cb();
                            vm.close();
                        }
                    });
                };
                const { vm, delErrList, delErrGroupList } = batchSelectModal({
                    title: type === 'company_name' ? '批量筛选客户名称' : '批量筛选集团名称',
                    props: { tip: placeholder || '输入或粘贴名称或ID，每行一个', hasLoading: true },
                    cbs: { onSubmit },
                });
            },
            handleSelectAll(list, type, selectType) {
                if (selectType === 'all') {
                    const data = [...(this.formData[type] || [])];
                    data.push(...list.map(v => v.value));
                    this.formData[type] = [...new Set(data)];
                } else {
                    const optionIds = this[`${type}_DataList`].map(item => item.value);
                    this.formData[type] = this.formData[type].filter(item => !optionIds.includes(item));
                }
            },
            handleVisibleChange(visible, type) {
                if (visible) {
                    const options = (this.$refs[type] && this.$refs[type].selected) || [];
                    this.$set(this, `${type}_DataList`, options.map(v => v.$options.propsData));
                }
            },
            // ——— 动态列 ———
            fetchGetCustomField() {
                this.loading = true;
                // ⚠️ 不带 sub_type：后端 subDenyFields 用 'scheduling_withdrawn' 这个键取屏蔽列。
                //    带了 sub_type 会拼成 'scheduling_withdrawn_x' 命中不到，恒空列会全冒出来。
                materialAPI.getCustomField({ field_type: 'scheduling_withdrawn' }).then(res => {
                    const result = res.data || {};
                    // ⚠️ 列池是从 field_type='work_order' 派生的，里面**带着 controls(操作列)**。
                    //    本 tab 只读、没有操作 → 必须剔除：不剔会渲染出一个空的操作列，
                    //    还会出现在「自定义列」弹窗里被用户勾上。
                    const DENY = ['controls'];
                    this.modalList = (result.field || []).map(group => {
                        if (group && group.children && group.children.length) {
                            return { ...group, children: group.children.filter(c => !DENY.includes(c.id)) };
                        }
                        return group;
                    }).filter(g => !g || !g.children || g.children.length > 0);
                    this.selectList = (result.user_field || []).filter(id => !DENY.includes(id));
                    const flat = [];
                    this.modalList.forEach(group => {
                        if (group && group.children && group.children.length) flat.push(...group.children);
                    });
                    const byId = {};
                    flat.forEach(c => { byId[c.id] = c; });
                    this.columns = this.selectList.map(id => byId[id]).filter(Boolean);
                    this.getList();
                }, err => {
                    this.loading = false;
                    this.$message.error((err && err.info) || '获取列配置失败');
                });
            },
            handleFieldTable() {
                const { vm } = fieldTableModal({
                    props: {
                        customClass: 'custom-indicator-new apple-custom-indicator',
                        customList: this.modalList,
                        selectList: this.selectList,
                    },
                    cbs: {
                        onSubmit: (data) => {
                            materialAPI.editCustomField({ field_type: 'scheduling_withdrawn', fields: data }).then(() => {
                                this.list = [];
                                this.fetchGetCustomField();
                                vm.close();
                            }, err => {
                                this.$message.error((err && err.info) || '保存失败');
                            });
                        },
                        onClose: () => { vm.close(); },
                    },
                });
            },
            cellText(row, id) {
                const v = row[id];
                if (v === null || v === undefined || v === '') return '-';
                if (Array.isArray(v)) {
                    // 对象数组交给上面的具名分支渲染；能落到这里的按字符串数组处理，
                    // 兜一层 name/info 取值，防止漏配分支时吐 [object Object]
                    return v.map(x => (x && typeof x === 'object') ? (x.name || x.info || '') : x)
                            .filter(x => x !== '' && x !== null && x !== undefined)
                            .join('；') || '-';
                }
                return v;
            },
            // 双击复制的文本（数组列复制成分号串，不复制 [object Object]）
            cellCopyText(id, row) {
                return String(this.cellText(row, id));
            },
            // ——— 排序 ———
            sortableOf(colId) {
                return this.sortableFields.includes(colId) ? 'custom' : false;
            },
            // 列宽拖动记忆（2026-08-31）：实现与指派 assign/index.vue::handleDragEnd 一致。
            // 排单管理这几个 tab 此前只能拖、刷新即还原——本页压根没挂 @header-dragend，
            // 也没在 :width 上读过存储值，属功能缺失而非失效。
            // ⚠️ jt-table 内部 TableHeader 既 v-on="$listeners" 又自己 @header-dragend，
            //    Vue2 同名事件会合并（两个 handler 都执行），故父组件挂载能正常收到回调。
            handleDragEnd(newWidth, oldWidth, column) {
                if (!column || !column.property) return;   // 序号/多选等无 prop 的列不记
                const next = Object.assign({}, this.colWidthMap, { [column.property]: parseInt(newWidth) });
                this.colWidthMap = next;
                setStorage('localStorage', 'scheduleWithdrawnTableWidthMap', next);
            },
            handleSortChange({ prop, order }) {
                if (order) {
                    this.orderFields = prop;
                    this.orderType = order === 'ascending' ? 'asc' : 'desc';
                } else {
                    this.orderFields = '';
                    this.orderType = '';
                }
                this.page = 1;
                this.getList();
            },
            // ——— 入参 ———
            buildQueryParams() {
                const fd = this.formData;
                const params = { ...fd };
                // 工单 widget：type1 → work_order(ids)；type2 → work_order_search(文本)
                if (this.woFilter.type === '1') {
                    if (this.woFilter.ids && this.woFilter.ids.length) params.work_order = this.woFilter.ids;
                    delete params.work_order_search;
                } else {
                    if (this.woFilter.search) params.work_order_search = this.woFilter.search;
                    delete params.work_order;
                }
                // 项目 widget 同理
                if (this.projFilter.type === '1') {
                    if (this.projFilter.ids && this.projFilter.ids.length) params.project_id = this.projFilter.ids;
                    delete params.project_name_search;
                } else {
                    if (this.projFilter.search) params.project_name_search = this.projFilter.search;
                    delete params.project_id;
                }
                // 投放场景/版位的选项 id 是同名多 id 的逗号聚合串（group_concat），
                // 不拆开后端 intval("3,4,5") 只会取到 3（口径同 boardSchedule / 指派）
                ['delivery_scene', 'delivery_type'].forEach(key => {
                    let flat = [];
                    (fd[key] || []).forEach(item => { flat = flat.concat(String(item).split(',')); });
                    params[key] = flat;
                });
                // 日期：后端 formatConditionsByParams 用 explode('/') 拆，必须拼成 "起/止" 单串。
                // _range 是纯前端中间态，必须 delete 掉——后端不认，留着白白撑大 POST 体积，
                // 还会在 withdrawnParams() 整包收 POST 时混进 $params 造成误读。
                delete params.expected_end_time_range;
                delete params.range_time_range;
                delete params.delete_time_range;
                delete params.rejected_time_range;
                const eet = fd.expected_end_time_range || [];
                if (eet[0] && eet[1]) params.expected_end_time = eet[0] + '/' + eet[1];
                const rt = fd.range_time_range || [];
                if (rt[0] && rt[1]) params.range_time = rt[0] + '/' + rt[1];
                // 撤回时间 / 驳回时间（2026-07-31）：键名与后端 o.delete_time / o.rejected_time 同名
                const dt = fd.delete_time_range || [];
                if (dt[0] && dt[1]) params.delete_time = dt[0] + '/' + dt[1];
                const jt = fd.rejected_time_range || [];
                if (jt[0] && jt[1]) params.rejected_time = jt[0] + '/' + jt[1];
                // 排序（后端 getWorkOrderList 路径吃 order_fields + order，口径同工单管理）。
                // 排序**不参与继承**：方案「非本期」已定——两边各自维护各自的排序状态。
                if (this.orderFields) {
                    params.order_fields = this.orderFields;
                    params.order = this.orderType;
                }
                return params;
            },
            // 空值判定：'' / null / undefined / 空数组 都算空（与后端 is_empty 口径对齐）
            isEmptyVal(v) {
                if (v === undefined || v === null || v === '') return true;
                return Array.isArray(v) && v.length === 0;
            },
            /**
             * 把 board（三 tab 共享查询）的筛选**写进本页 formData**，让已撤回 tab 与那三个 tab 表现一致
             *   —— 切过来筛选生效、控件里看得见、能改能清、点重置能清干净。
             *
             * 🔴 为什么是「写回 formData」而不是「只补出参」（2026-07-31 修）：
             *    最初实现只把继承值补在 buildQueryParams 的出参上，结果筛选生效但控件是空的，
             *    只能再加一条「已沿用 N 项筛选」的提示条去打补丁 —— 那正是本文件其它注释里
             *    反复警告的「看不见但仍在生效的隐藏筛选」。需求方要求与三 tab 保持一致，
             *    写回 formData 才是对的，那条提示条也随之删掉。
             *
             * 🔴 只在**挂载时一次性**执行（本组件是 v-if 挂载/销毁，每次切进来都会重新跑）。
             *    写进去之后它就是普通的 formData 值，用户改它、清它、点重置，行为与手填的完全一样——
             *    不需要任何「继承值优先级 / 用户动过就丢弃」的额外状态机。
             *
             * ⚠️ 时序：必须在 fetchGetFilter 拿到 customFilter 之后调用，且继承的键要一并塞进
             *    customFilter，否则控件被 getCustomFilterShow 挡住不渲染。
             *
             * ⚠️ 只收 SHARED_INHERIT_KEYS 白名单，board 特有的排单键（scheduling_status / group_id /
             *    delivery* / expect_finish_date* / bloc_star / overdue / priority / category_group_id /
             *    cross_cat / page / page_size / order_fields / order）一律不进来——
             *    它们要么在本 tab 无意义，要么后端会按**另一套语义**解释。
             *    ctime_start/ctime_end ↔ range_time、group_id ↔ material_group 同义但不同名/不同语义，
             *    故意不做键名翻译（一旦开始翻译，两边任一侧改格式就会悄悄漂掉）。
             */
            applySharedFilters() {
                const src = this.sharedParams || {};
                const fd  = src.formData || {};
                SHARED_INHERIT_KEYS.forEach(key => {
                    if (!(key in this.formData)) return;
                    let v = fd[key];
                    if (this.isEmptyVal(v)) return;
                    // board 单选标量 → 本页多选数组（见 SCALAR_ON_BOARD_KEYS 注释）
                    if (SCALAR_ON_BOARD_KEYS.indexOf(key) > -1 && !Array.isArray(v)) v = [v];
                    this.$set(this.formData, key, Array.isArray(v) ? v.slice() : v);
                    if (this.customFilter.indexOf(key) === -1) this.customFilter.push(key);
                });
                // 工单 / 项目：不在 formData 里，由独立 widget 管理，整体搬过来
                const wo = src.woFilter;
                if (wo && ((wo.ids && wo.ids.length) || wo.search)) {
                    this.woFilter = { ...wo };
                    if (this.customFilter.indexOf('work_order') === -1) this.customFilter.push('work_order');
                }
                const pj = src.projFilter;
                if (pj && ((pj.ids && pj.ids.length) || pj.search)) {
                    this.projFilter = { ...pj };
                    if (this.customFilter.indexOf('project_id') === -1) this.customFilter.push('project_id');
                }
            },
            // ——— 数据 ———
            async getList() {
                this.loading = true;
                try {
                    const { data } = await API.getWithdrawnList({
                        ...this.buildQueryParams(),
                        fields: this.selectList,
                        pn: this.page,
                        rn: this.pageSize,
                    });
                    this.list = (data && data.list) || [];
                    this.total = (data && data.totalCnt) || 0;
                } catch (error) {
                    this.$message.error((error && error.info) || '加载失败');
                } finally {
                    this.loading = false;
                }
            },
            async exportData() {
                try {
                    this.exportLoading = true;
                    const res = await API.exportWithdrawn({
                        ...this.buildQueryParams(),
                        fields: this.selectList,
                    });
                    this.$message.success((res && res.info) || '导出成功，请稍后下载');
                } catch (error) {
                    this.$message.error((error && error.info) || '导出失败');
                } finally {
                    this.exportLoading = false;
                }
            },
            // counts-changed：本 tab 在前台时徽标吃的就是本组件的 buildQueryParams()
            // （index.vue currentQueryParams），查询条件一变必须同步刷徽标，否则又是「徽标 51、点进去 54」。
            refresh() { this.getList(); this.$emit('counts-changed'); },
            handleSearch() { this.page = 1; this.getList(); this.$emit('counts-changed'); },
            handleReset() {
                this.formData = this.defaultForm();
                this.woFilter = { type: '1', ids: [], search: '' };
                this.projFilter = { type: '1', ids: [], search: '' };
                // 重置 = 一张干净的表。继承来的值此刻已是普通 formData 值，defaultForm() 一并清掉；
                // 之后想再继承只能重新切一次 tab（与三 tab 互切的手感一致）。
                this.page = 1;
                this.getList();
                this.$emit('counts-changed');
            },
            onPageChange(p) { this.page = p; this.getList(); },
            onSizeChange(s) { this.pageSize = s; this.page = 1; this.getList(); },
        },
    };
</script>

<style scoped lang="scss">
    @import "~@/styles/material_sd.scss";

    // 查询区布局与 boardSchedule（待排单/已排单/已定版）保持一致：
    // 查询/重置在一条分隔线下方左对齐，query-box padding 与工具栏 gap/op-tip 同口径。
    .board-withdrawn { padding: 4px 0; }
    .query-box { background: #fff; padding: 20px 10px; border-radius: 4px; }
    .query-box ::v-deep .el-form-item { margin-bottom: 10px; }
    .filter-bar { margin-bottom: 4px; }
    .opts { border-top: 1px solid #DCDFE6; padding-top: 10px; }
    .operation-box { display: flex; justify-content: space-between; align-items: center; }
    .operation-left { display: flex; align-items: center; flex-wrap: wrap; }
    .operation-right { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }
    .op-tip { margin-left: 8px; color: #909399; font-size: 12px; display: inline-block; max-width: 640px; white-space: normal; line-height: 1.4; vertical-align: middle; }
    .option-select { display: flex; justify-content: space-around; margin: 0; padding: 0 10px; }
    .tar { text-align: right; }
    .board-withdrawn ::v-deep .header-cell { background: #e8eaec !important; color: #333 !important; }
    .cell-line { line-height: 1.6; }
    .cell-wrap { white-space: normal; line-height: 1.6; color: #606266; }
</style>
